var map = {
	"./acc/coupon/index": 7100,
	"./acc/recharge/index": 8614,
	"./acc/record/index": 5698,
	"./acc/reward/index": 8224,
	"./bus/addLogFee/index": 3481,
	"./bus/answer/index": 6482,
	"./bus/area/index": 6170,
	"./bus/banner/index": 182,
	"./bus/cashApply/index": 6683,
	"./bus/comment/index": 607,
	"./bus/config/index": 8013,
	"./bus/docDown/index": 3149,
	"./bus/level/index": 102,
	"./bus/level/record/index": 4940,
	"./bus/live/index": 3927,
	"./bus/logTemplate/index": 6153,
	"./bus/logrule/index": 8383,
	"./bus/lottery/act/index": 2652,
	"./bus/lottery/count/index": 4489,
	"./bus/lottery/goods/index": 7164,
	"./bus/lottery/record/index": 1432,
	"./bus/mall/card/index": 7041,
	"./bus/material/index": 6686,
	"./bus/order/index": 749,
	"./bus/orderUnion/index": 8917,
	"./bus/question/index": 375,
	"./bus/saleTypes/index": 4520,
	"./bus/shop/index": 4959,
	"./bus/shopParam/index": 3199,
	"./bus/sign/index": 7073,
	"./bus/stores/index": 597,
	"./bus/top/record/index": 4102,
	"./bus/type/index": 9599,
	"./cus/user/index": 7370,
	"./dashboard/admin/components/TodoList/index": 3003,
	"./dashboard/admin/index": 6406,
	"./dashboard/index": 9226,
	"./lesson/card/index": 3739,
	"./lesson/course/index": 3821,
	"./lesson/sign/index": 2627,
	"./login/index": 8389,
	"./redirect/index": 7809,
	"./store/order/index": 4781,
	"./store/record/index": 3984,
	"./store/sec/code/index": 845,
	"./store/stock/index": 6810,
	"./sys/dept/index": 2752,
	"./sys/menu/index": 3620,
	"./sys/role/index": 3316,
	"./sys/user/index": 8108,
	"./sys/wxconfig/index": 5279,
	"./wares/act/index": 820,
	"./wares/goods/index": 7800,
	"./wares/price/index": 1652
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2128;